import React from 'react';
import LineChart from './index';

/**
 * 模拟数据 - 游戏收入趋势（多系列多日期）
 */
const MOCK_REVENUE_DATA: ILineChartData[] = [
  { date: '2024-01', name: 'Game A', value: 12500 },
  { date: '2024-02', name: 'Game A', value: 9800 },
  { date: '2024-03', name: 'Game A', value: 7500 },
  { date: '2024-04', name: 'Game A', value: 6200 },
  { date: '2024-05', name: 'Game A', value: 4800 },
  { date: '2024-06', name: 'Game A', value: 4200 },
  { date: '2024-01', name: 'Game B', value: 4500 },
  { date: '2024-02', name: 'Game B', value: 5200 },
  { date: '2024-03', name: 'Game B', value: 8500 },
  { date: '2024-04', name: 'Game B', value: 12000 },
  { date: '2024-05', name: 'Game B', value: 9500 },
  { date: '2024-06', name: 'Game B', value: 7800 },
];

/**
 * 模拟数据 - 留存率（小数值，用于演示百分比格式化）
 */
const MOCK_RETENTION_DATA: ILineChartData[] = [
  { date: '2024-01', name: 'Day 1', value: 0.452 },
  { date: '2024-02', name: 'Day 1', value: 0.485 },
  { date: '2024-03', name: 'Day 1', value: 0.521 },
  { date: '2024-01', name: 'Day 7', value: 0.225 },
  { date: '2024-02', name: 'Day 7', value: 0.258 },
  { date: '2024-03', name: 'Day 7', value: 0.282 },
  { date: '2024-01', name: 'Day 30', value: 0.082 },
  { date: '2024-02', name: 'Day 30', value: 0.095 },
  { date: '2024-03', name: 'Day 30', value: 0.112 },
];

/**
 * 自定义 Y 轴美元格式化
 */
const dollarFormatter = (value: number | null): string => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '-';
  }
  return `$${(value / 1000).toFixed(1)}K`;
};

/**
 * 基础用法：多系列折线图
 */
const BasicDemo: React.FC = () => {
  return (
    <div style={{ width: '100%', height: 400 }}>
      <LineChart loading={false} data={MOCK_REVENUE_DATA} />
    </div>
  );
};

/**
 * 自定义 Y 轴格式化
 */
const CustomYAxisDemo: React.FC = () => {
  return (
    <div style={{ width: '100%', height: 400 }}>
      <LineChart
        loading={false}
        data={MOCK_REVENUE_DATA}
        yAxisLabelFormatter={dollarFormatter}
      />
    </div>
  );
};

/**
 * X 轴标签旋转
 */
const RotateXAxisDemo: React.FC = () => {
  return (
    <div style={{ width: '100%', height: 400 }}>
      <LineChart
        loading={false}
        data={MOCK_REVENUE_DATA}
        useXAxisLabelRotate
      />
    </div>
  );
};

/**
 * 网格线虚线样式
 */
const DashedGridDemo: React.FC = () => {
  return (
    <div style={{ width: '100%', height: 400 }}>
      <LineChart
        loading={false}
        data={MOCK_RETENTION_DATA}
        gridLineStyle="dashed"
      />
    </div>
  );
};

/**
 * 图例左对齐
 */
const LegendLeftDemo: React.FC = () => {
  return (
    <div style={{ width: '100%', height: 400 }}>
      <LineChart
        loading={false}
        data={MOCK_REVENUE_DATA}
        legendAlign="left"
      />
    </div>
  );
};

export const demoConfig = [
  {
    title: '基础用法',
    description: '多系列折线图，展示两组游戏在 6 个月的收入趋势。',
    code: `<LineChart loading={false} data={MOCK_REVENUE_DATA} />`,
    element: <BasicDemo />,
  },
  {
    title: '自定义 Y 轴格式化',
    description: '通过 yAxisLabelFormatter 将 Y 轴数值格式化为美元 K 单位显示。',
    code: `<LineChart
  loading={false}
  data={MOCK_REVENUE_DATA}
  yAxisLabelFormatter={dollarFormatter}
/>`,
    element: <CustomYAxisDemo />,
  },
  {
    title: 'X 轴标签旋转',
    description: '当 X 轴标签较长时，通过 useXAxisLabelRotate 启用 45 度旋转。',
    code: `<LineChart
  loading={false}
  data={MOCK_REVENUE_DATA}
  useXAxisLabelRotate
/>`,
    element: <RotateXAxisDemo />,
  },
  {
    title: '网格线虚线样式',
    description: '通过 gridLineStyle 设置网格线为虚线样式。',
    code: `<LineChart
  loading={false}
  data={MOCK_RETENTION_DATA}
  gridLineStyle="dashed"
/>`,
    element: <DashedGridDemo />,
  },
  {
    title: '图例左对齐',
    description: '通过 legendAlign 将图例左对齐。',
    code: `<LineChart
  loading={false}
  data={MOCK_REVENUE_DATA}
  legendAlign="left"
/>`,
    element: <LegendLeftDemo />,
  },
];

export default demoConfig;
